import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

// icons
import { MagnifyingGlass } from '@phosphor-icons/react';

interface SearchFieldProps {
    value: string;
    onChange:
        | React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
        | undefined;
    label: string;
    sx?: SxProps<Theme>;
    size?: 'small' | 'medium';
}

const SearchField: React.FC<SearchFieldProps> = ({
    value,
    onChange,
    label,
    sx,
    size,
}) => {
    return (
        <TextField
            id={`searchField-${label}`}
            label={label}
            variant="outlined"
            value={value}
            onChange={onChange}
            sx={sx}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <MagnifyingGlass size={24} color="#4D4D4D" />
                    </InputAdornment>
                ),
            }}
            size={size}
            fullWidth
        />
    );
};

export default SearchField;
